import { THEMES, type Theme } from '../consts';

/**
 * Resolves the colour scheme to apply from the stored preference and the
 * dark-mode feature flag. A stored `dark` while the flag is off falls back to
 * light — so revoking the flag can never leave someone stuck in dark mode
 * with no way back. (An absent or corrupt stored value never reaches here —
 * the theme store's `merge` already sanitises it to light.)
 */
export const resolveTheme = (storedTheme: Theme, isDarkModeAllowed: boolean) =>
  isDarkModeAllowed && storedTheme === THEMES.DARK ? THEMES.DARK : THEMES.LIGHT;
